<div class="inner-router-wrapper">
    <div class="header-with-cta">
        <div class="dash-header">
            <div class="list">
                <div class="title-dialog">
                    <p>Terms</p>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-body">
        <table>
            <tr *ngFor="let item of terms; let i = index">
                <td>
                    <div class="item">
                        <p>
                            {{item['TermsDescription']}}
                        </p>
                        <div class="children" *ngIf="item['Children'].length">
                            <ul>
                                <li *ngFor="let child of item['Children']">
                                    {{child['TermsDescription']}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="item rtl">
                        <p>{{item['TermsDescriptionOtherLanguage']}}</p>
                        <div class="children" *ngIf="item['Children'].length">
                            <ul>
                                <li *ngFor="let child of item['Children']">
                                    {{child['TermsDescriptionOtherLanguage']}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
<br><br>
        </div>
</div>